import { Injectable } from '@angular/core';
import { of, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ActivatedRouteSnapshot } from '@angular/router';
import { LoaderService } from '../../common/services/loader.service';
import { PermitService } from "../../common/services/permit.service";
import { LandownerPassthroughProgramApplication } from "../../common/models/permit.model";


@Injectable()
export class LandownerApplicationResolver  {
  constructor(public dataService: PermitService,
              public loaderService: LoaderService) {
  }

    resolve(route: ActivatedRouteSnapshot) {
      this.loaderService.toggleLoader(true);
      let obs$: Observable<LandownerPassthroughProgramApplication>;
      if (route.paramMap.get('id')) {
          obs$ = this.dataService.findLandownerPassthroughApplicationById(route.paramMap.get('id'));
          } else {
          obs$ = of(null);
      }
      return obs$.pipe(tap((data) => {
          this.loaderService.toggleLoader(false);
      }));
  }
}